import { meta } from "./meta";
import { GameScene } from "./scenes/GameScene";
import { MozaikMap } from "./saga";

/** Embeddable game contract (docs/design/platform.md). Like every arcade game: the level map opens first. */
export const game = { meta, scenes: [MozaikMap, GameScene] };
